import { render, staticRenderFns } from "./Create.vue?vue&type=template&id=a98d3c46&scoped=true"
import script from "./Create.vue?vue&type=script&lang=js"
export * from "./Create.vue?vue&type=script&lang=js"
import style0 from "./Create.vue?vue&type=style&index=0&id=a98d3c46&prod&scoped=scoped&lang=css"
import style1 from "./Create.vue?vue&type=style&index=1&id=a98d3c46&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a98d3c46",
  null
  
)

export default component.exports